import { render } from "./countryWarning.vue?vue&type=template&id=13e71749&scoped=true&lang=pug"
import script from "./countryWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./countryWarning.vue?vue&type=script&setup=true&lang=js"

import "./countryWarning.vue?vue&type=style&index=0&id=13e71749&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e71749"]])

export default __exports__